// extracted by mini-css-extract-plugin
export default {"notAvailable":"styles_notAvailable__v5+sN","cartItem":"styles_cartItem__dABda","index":"styles_index__bDhqG","margin51":"styles_margin51__W1umX"};